import FileType, { FileTypeType } from '@constants/fileType';
import getFileType from './getFileType';

const priorityOfFileType = [
  FileType.INSPECTION_SUMMARY,
  FileType.ACTION_SUMMARY,
  FileType.REPORT,
  FileType.UNKNOWN,
];

export default function fileSortingComparator(fileA: File, fileB: File) {
  const fileTypeA = getFileType(fileA.name);
  const fileTypeB = getFileType(fileB.name);

  return (
    priorityOfFileType.indexOf(fileTypeA as FileTypeType) -
    priorityOfFileType.lastIndexOf(fileTypeB as FileTypeType)
  );
}
